module.exports = __webpack_public_path__ + "08_face.6527fae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/08_face.png
// module id = Rimo
// module chunks = 0